import { createComponent } from '../core/create-component.js';

/**
 * @subcomponent StepIndicator
 */ const StepIndicatorStepList = createComponent({
    displayName: 'StepIndicatorStepList',
    root: 'ol'
});

export { StepIndicatorStepList };
